import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';
import DetailModal from '../../Components/DetailModal';

const Leads = () => {
    const Swal = window.Swal;

    const limit = 10;
    const [leads, setLeads] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    useEffect(() => {
        const fetchLeads = async (page = 1) => {
            try {
                setLoading(true);
                const offset = (page - 1) * limit;
                const res = await api.get(`/leads/list?limit=${limit}&offset=${offset}`);
                if (res.status === 200) {
                    console.log(res.data.leads)
                    setLeads(res.data.leads || []);
                    const total = res.data.total || 0;
                    setTotalPages(Math.ceil(total / limit) || 1);
                }
            } catch (err) {
                handleErrors(err);
            } finally {
                setLoading(false);
            }
        };

        fetchLeads(currentPage);
    }, [currentPage]);

    const handleViewDetail = async (id) => {
        try {
            setModalLoading(true);
            setShowModal(true);
            const res = await api.get(`/leads/${id}`);
            if (res.status === 200) {

                let data = res.data.lead

                setModalData(data);
            }
        } catch (err) {
            handleErrors(err);
            setShowModal(false);
        } finally {
            setModalLoading(false);
        }
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            html: '<i class="fas fa-trash-alt" style="font-size: 42px; color: #d33; margin-bottom: 10px;"></i><p>This will permanently delete the subscriber!</p>',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await api.delete(`/leads/${id}`);
                    if (res.status === 200) {
                        showToast('success', res.data.message || 'Lead deleted successfully', 'Deleted');
                        setLeads(prev => prev.filter(s => s._id !== id));
                    }
                } catch (err) {
                    handleErrors(err);
                }
            }
        });
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.ROOT}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.LEADS}>Leads</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Leads</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                {loading ? (
                                    <div className="text-center my-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <table className="table table-responsive-md">
                                        <thead>
                                            <tr>
                                                <th><strong>#</strong></th>
                                                <th><strong>Name</strong></th>
                                                <th><strong>Email</strong></th>
                                                <th><strong>Phone</strong></th>
                                                <th><strong>Company Names</strong></th>
                                                <th><strong>Actions</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leads && leads.length > 0 ? leads.map((lead, index) => (
                                                <tr key={lead._id || index} style={{ cursor: 'pointer' }}>
                                                    <td><strong>{((currentPage - 1) * limit) + (index + 1)}</strong></td>
                                                    <td>{lead.name || 'N/A'}</td>
                                                    <td>{lead.email || 'N/A'}</td>
                                                    <td>{lead.phone || 'N/A'}</td>
                                                    <td>{lead.company_name || 'N/A'}</td>
                                                    <td>
                                                        <div className="d-flex" onClick={(e) => e.stopPropagation()}>
                                                            <button
                                                                className="btn btn-primary shadow btn-xs sharp me-1"
                                                                onClick={() => handleViewDetail(lead._id)}
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </button>
                                                            <button
                                                                className="btn btn-danger shadow btn-xs sharp"
                                                                onClick={() => handleDelete(lead._id)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">No leads found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                        <div className="card-footer">
                            <ul className="pagination pagination-gutter pagination-primary no-bg">
                                <li className={`page-item page-indicator ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <a className="page-link" href="#/" onClick={(e) => { e.preventDefault(); setCurrentPage(prev => Math.max(prev - 1, 1)); }}>
                                        <i className="la la-angle-left"></i>
                                    </a>
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li className={`page-item ${currentPage === i + 1 ? 'active' : ''}`} key={i}>
                                        <a className="page-link" href="#/" onClick={(e) => { e.preventDefault(); setCurrentPage(i + 1); }}>{i + 1}</a>
                                    </li>
                                ))}
                                <li className={`page-item page-indicator ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <a className="page-link" href="#/" onClick={(e) => { e.preventDefault(); setCurrentPage(prev => Math.min(prev + 1, totalPages)); }}>
                                        <i className="la la-angle-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <DetailModal
                show={showModal}
                onHide={() => setShowModal(false)}
                title="Lead Detail"
                data={modalData}
                loading={modalLoading}
            />
        </>
    );
};

export default Leads;
